import Carousel from '../../components/base/Carousel';
import InfoCard from '../../components/InfoCard';
import { setBasketCount } from '../../scripts/backend/common-catalog';

function addProgramToBasket() {
    const programId = $(this).data('program-id');
    $.post(`/api/internal/basket/add-program/${programId}`, result => {
        if (result.success) {
            setBasketCount(result.data.total.itemCount);
        }
    });
}

/**
 * Инициализация карусели "Программа ухода"
 * И карточек внутри неё
 */
export default () => {
    const $carouselInfoCards = $('.carousel--info-cards');
    const carouselInfoCards = new Carousel($carouselInfoCards);
    const infoCards = new InfoCard($carouselInfoCards.find('.info-cards'));

    infoCards.init();

    // Нужно навешивать на "load", чтобы корректно были подсчитаны размеры
    $(window).on('load', () => {
        carouselInfoCards.init(
            { spaceBetween: 12 },
            {
                slidesPerView: 3,
                breakpoints: {
                    1023: { slidesPerView: 2 },
                    767: { slidesPerView: 1 },
                },
            }
        );
    });

    $(document).on('click', '.js-add-program-to-basket', addProgramToBasket);
};
